import {hot} from 'react-hot-loader/root';
import React from 'react';
import {IntlProvider} from 'react-intl';
import PageContainer from '../PageContainer';

interface AppOptions {
    intl: IntlObject;
}

const App = ({intl}: AppOptions) => (
    <IntlProvider
        messages={intl.messages}
        locale={intl.locale}
        defaultLocale={intl.defaultLocale}
    >
        <PageContainer />
    </IntlProvider>
);

export default hot(App);
